import React from 'react';
import { Switch } from 'react-router-dom';
import './scss/index.scss';
import '@progress/kendo-theme-default/dist/all.css';

//public view pages:
import RouteLayout from './Components/PublicView/Layout';
import StoreLayout from './Components/PublicView/StoreLayout';
import Home from './Components/PublicView/Pages/Home/Home';
import RegisterConfirmation from './Components/PublicView/Pages/EndUser/Signup/Membership/RegisterConfirmation';
import RegisterError from './Components/PublicView/Pages/EndUser/Signup/Membership/RegisterError';
import ResetPassword from './Components/PublicView/Pages/EndUser/PasswordManagement/ResetPassword';
import ChangePassword from './Components/PublicView/Pages/EndUser/PasswordManagement/ChangePassword';
import SignupWizardLayout from './Components/PublicView/SignupWizard/SignupWizardLayout';
import SignupLayout from './Components/PublicView/SignupLayout';
import BlogHome from './Components/PublicView/Pages/EndUser/Blog/BlogHome';
import BlogDetails from './Components/PublicView/Pages/EndUser/Blog/BlogDetails';
import EventsHome from './Components/PublicView/Pages/EndUser/Events/EventsHome';
import EventDetails from './Components/PublicView/Pages/EndUser/Events/EventDetails';
import ShoppingCart from './Components/PublicView/Pages/EndUser/Store/ShoppingCart/ShoppingCart';
import StoreHome from './Components/PublicView/Pages/EndUser/Store/StoreHome';
import AccountCreate from './Components/PublicView/Pages/AccountCreate/AccountCreate';
import Login from './Components/PublicView/Pages/Login/Login';
import UserPurchasesPage from './Components/PublicView/Pages/Dashboard/UserPurchasesPage';
import UserDashboardPage from './Components/PublicView/Pages/Dashboard/UserDashboardPage/UserDashboardPage';
import UserAccountPage from './Components/PublicView/Pages/MyAccount/UserAccountPage/UserAccountPage';
import MembershipsPage from './Components/PublicView/Pages/MyMemberships/MembershipsPage/MembershipsPage';
import OrganizationsPage from './Components/PublicView/Pages/MyOrganizations/OrganizationsPage';
import BillingInformation from './Components/PublicView/Pages/EndUser/Signup/Billing/BillingInformation/BillingInformation';
import Oops from './Components/PublicView/Pages/Oops';
import Payment from './Components/PublicView/Pages/Payment';
import CommitteesPage from './Components/PublicView/Pages/MyCommittees/CommitteesPage/CommitteesPage';
import EndUserArchive from './Components/PublicView/Pages/EndUser/Archive/EndUserArchive';
import MemberDiscounts from './Components/PublicView/Pages/EndUser/MemberDiscounts/MemberDiscounts';
import ExistingMember from './Components/PublicView/Pages/EndUser/ExisitingMember/ExsistingMember';
import ExistingMemberConfirmation from './Components/PublicView/Pages/EndUser/Signup/Membership/ExistingMemberConfirmation';
// Admin Pages
import AdminLayout from './Components/AdminView/AdminLayout';
import ManageMembership from './Components/AdminView/Pages/Administration/ManageMembership/ManageMemberships';
import ManageOrganization from './Components/AdminView/Pages/Administration/ManageOrganization/ManageOrganizations';
import ManageArchive from './Components/AdminView/Pages/Administration/ManageArchive/ManageArchive';
import ManageUsers from './Components/AdminView/Pages/Administration/ManageUsers/ManageUsers';
import ManageSubscriptions from './Components/AdminView/Pages/Administration/ManageSubscriptions/ManageSubscriptions';
import SetupPassword from './Components/AdminView/Pages/Administration/SetupPassword';
import Districts from './Components/AdminView/Pages/Administration/ManageDistricts/ManageDistricts';
import Regions from './Components/AdminView/Pages/Administration/ManageRegions/ManageRegions';
import Committees from './Components/AdminView/Pages/Administration/ManageCommittees/ManageCommittees';
import PositionGroups from './Components/AdminView/Pages/Administration/ManagePositionGroups/ManagePositionGroups';
import ManagePositions from './Components/AdminView/Pages/Administration/ManagePositions/ManagePositions';
import ManageEvents from './Components/AdminView/Pages/Administration/ManageEvents/ManageEvents';
import ManageColors from './Components/AdminView/Pages/Administration/ManageColors/ManageColors';
import ManageSizes from './Components/AdminView/Pages/Administration/ManageSizes/ManageSizes';
import ManageProducts from './Components/AdminView/Pages/Administration/ManageProducts/ManageProducts';
import ManageProductTypes from './Components/AdminView/Pages/Administration/ManageProductTypes/ManageProductTypes';
import ManageInvoices from './Components/AdminView/Pages/Administration/ManageInvoices/ManageInvoices';
import ManagePurchaseAndRenewals from './Components/AdminView/Pages/Administration/ManagePurchaseAndRenewals/ManagePurchaseAndRenewals';
import ManageOrderManagement from './Components/AdminView/Pages/Administration/ManageOrders/ManageOrders';
import ManageMembershipUsers from './Components/AdminView/Pages/Administration/ManageMembershpUsers/ManageMembershipUsers';
import ManageMemberDiscounts from './Components/AdminView/Pages/Administration/ManageMemberDiscounts/ManageMemberDiscounts';
import ManageMembershipRequests from './Components/AdminView/Pages/Administration/ManageMembershipRequests/ManageMembershipRequests';
import Donations from './Components/AdminView/Pages/Administration/Reports/Donations';
import ManageBatches from './Components/AdminView/Pages/Administration/ManageBatches/ManageBatches';

// Test Page
import ParentPage from './Components/PublicView/Pages/AddressValidationTest/ParentPage';
import { ROOT_API_URL } from './api-config';

const packageJson = require('../package.json');
global.appVersion = packageJson.version;
console.log(global.appVersion);

const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);

    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());

        const b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) continue;
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
    }
    return false;
};

fetch(`${ROOT_API_URL}/launch`, { cache: "no-store" })
    .then((response) => response.json())
    .then((launch) => {
        const latestVersion = launch.appVersion;
        const currentVersion = global.appVersion;

        const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
        if (shouldForceRefresh) {
            console.log(`We have a new version - ${latestVersion}. Should force refresh`);
            if (caches) {
                // Service worker cache should be cleared with caches.delete()
                caches.keys().then(function (names) {
                    for (let name of names) caches.delete(name);
                });
            }
            // delete browser cache and hard reload
            window.location.reload(true);
        } else {
            // console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);   
        }
    })
;

var IdealTimeOut = 7; // 7 * 5minutes
var idleSecondsTimer = null;
var idleSecondsCounter = 0;
document.onclick = function () { idleSecondsCounter = 0; };
document.onmousemove = function () { idleSecondsCounter = 0; };
document.onkeypress = function () { idleSecondsCounter = 0; };
idleSecondsTimer = window.setInterval(CheckIdleTime, 300000);

function CheckIdleTime() {

    if (!localStorage.authUser || !localStorage.length) {
        idleSecondsCounter = 0;
        return;
    }

    idleSecondsCounter++;

    // logout if user idle for at lease 30 minutes.
    // ( if user clicked, typed, or moved cursor right before the function called, then it will log out after idle for at most 35 minutes).

    if (idleSecondsCounter >= IdealTimeOut) {
        window.clearInterval(idleSecondsTimer);
        alert("Your Session has expired. Please login again.");
        localStorage.removeItem('authUser');
        localStorage.removeItem('auth-user-details');
        window.location = window.location.origin + '/login';
    }
}

export default () => (
  <div className="h-100">
    <Switch>
      <RouteLayout exact path="/" component={Home} />
      <RouteLayout path="/home" component={Home} />
      <RouteLayout path="/dashboard" component={UserDashboardPage} />
      <RouteLayout path="/dashboard-purchases" component={UserPurchasesPage} />
      <RouteLayout path="/my-account" component={UserAccountPage} />
      <RouteLayout path="/my-membership" component={MembershipsPage} />
      <RouteLayout path="/my-organization" component={OrganizationsPage} />
      <RouteLayout path="/registerConfirmation" component={RegisterConfirmation} />
      <RouteLayout path="/existingMemberConfirmation" component={ExistingMemberConfirmation} />
      <RouteLayout path="/registerError" component={RegisterError} />
      <RouteLayout path="/billingInformation" component={BillingInformation} />
      <RouteLayout path="/resetpassword" component={ResetPassword} />
      <RouteLayout path="/changepassword" component={ChangePassword} />
      <RouteLayout path="/accountcreate" component={AccountCreate} />
      <RouteLayout path="/login" component={Login} />
      <RouteLayout path="/blog" component={BlogHome} />
      <RouteLayout path="/blogdetails/:blogTitle" component={BlogDetails} />
      <RouteLayout path="/events" component={EventsHome} />
      <RouteLayout path="/archive" component={EndUserArchive}/>
      <RouteLayout path="/memberdiscount" component={MemberDiscounts}/>
      <RouteLayout path="/eventdetails/:eventTitle" component={EventDetails} />
      <RouteLayout path="/oops" component={Oops} />
      <RouteLayout path="/payment" component={Payment} />
      <RouteLayout path="/existingmember" component={ExistingMember} />
      <SignupLayout path="/signupwizard" component={SignupWizardLayout} />
      <SignupLayout path="/membership" component={SignupWizardLayout} />
      <SignupLayout path="/membership/:userId" component={SignupWizardLayout} />
      <RouteLayout path="/shoppingcart" component={ShoppingCart} />
      <StoreLayout path="/store" component={StoreHome} />
      <StoreLayout path="/store/:categoryId" component={StoreHome} />
      <RouteLayout path="/mycommittee/:committeeMemberId" component={CommitteesPage} />

      {/* Test */}
      <RouteLayout path="/test" component={ParentPage} />

      {/* Admin Pages */}			
      <AdminLayout path="/admin/archive" component={ManageArchive} />
      <AdminLayout path="/admin/membership" component={ManageMembership} />
      <AdminLayout path="/admin/organization" component={ManageOrganization} />
      <AdminLayout path="/admin/users" component={ManageUsers} />
      <AdminLayout path="/admin/districts" component={Districts} />
      <AdminLayout path="/admin/regions" component={Regions} />
      <AdminLayout path="/admin/committees" component={Committees} />
      <AdminLayout path="/admin/groups" component={PositionGroups} />
      <AdminLayout path="/admin/positions" component={ManagePositions} />
      <AdminLayout path="/admin/events" component={ManageEvents} />
      <AdminLayout path="/admin/colors" component={ManageColors} />
      <AdminLayout path="/admin/sizes" component={ManageSizes} />
      <AdminLayout path="/admin/products" component={ManageProducts} />
      <AdminLayout path="/admin/productTypes" component={ManageProductTypes} />
      <AdminLayout path="/admin/subscription" component={ManageSubscriptions} />
      <AdminLayout path="/admin/invoices" component={ManageInvoices} />
      <AdminLayout path="/admin/purchaseandrenewals" component={ManagePurchaseAndRenewals} />
      <AdminLayout path="/admin/orderManagement" component={ManageOrderManagement} />
      <AdminLayout path="/admin/membershipusers" component={ManageMembershipUsers} />
      <AdminLayout path="/admin/memberdiscounts" component={ManageMemberDiscounts} />
      <AdminLayout path="/admin/membershiprequests" component={ManageMembershipRequests} />
      <AdminLayout path="/admin/donations" component={Donations} />
      <AdminLayout path="/admin/batches" component={ManageBatches} />
      <RouteLayout path="/setuppassword" component={SetupPassword} />
    </Switch>
  </div>
);